
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeSelectModule } from 'primeng/treeselect';
import { UserService } from '../../../../../user/services/user.service';
import { CategoryService } from '../../../../service/category.service';
import { CommonModule } from '@angular/common';
import { ChannelService } from '../../../../service/channel.service';
import { PanelModule } from 'primeng/panel';
import { DataViewModule } from 'primeng/dataview';
import { Message} from 'primeng/message';
import { ActivatedRoute } from '@angular/router';
import { MappingService } from '../../../mapping/mapping.service';
import { ShopService } from '../../../../../shop/service/shop.service';
import { Util } from '../../../../../../utils/util';
@Component({
  selector: 'app-mapping-widget-value',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    TreeSelectModule,
    ButtonModule,
    DialogModule,
    SelectModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ToastModule,
    PanelModule,
    DataViewModule,
    Message
  ],
  providers: [MessageService],
  templateUrl: './mapping-widget-value.component.html',
  styleUrl: './mapping-widget-value.component.scss',
})
export class MappingWidgetValueComponent implements OnInit {
  @Input() associated = false;
  @Input() type;
  @Input() importShopCode;
  nodes;
  data;
  loading = false;
  searchKeyword = '';
  values;
  details = [];
  totalRecords;

  scroll: number;
  cols = [{ header: 'label', field: 'label' }];
  rows = 1;
  selectedValue;
  showDialog = false;
  workingNode;
  selectedNode;
  attributes;
  selectedAttribute;
  categories;
  selectedCategory;
  associatedNodes = [];
  constructor(
    private readonly userService: UserService,
    private readonly messageService: MessageService,
    private readonly channelService: ChannelService,
    private readonly categoryService: CategoryService,
    private readonly mappingService: MappingService,
    private readonly shopService: ShopService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.initCategories();
    const importId = this.route.snapshot.paramMap.get('id');
    const data = {
      vendorId: this.importShopCode,
      importId: importId,
      filter: {
        locale: this.channelService.getSelectedLocale(),
        label: this.searchKeyword,
        offset: 0,
        limit: this.rows,
      },
    };
    this.getMappingValues(data);
  }

  getMappingValues(data) {
    this.mappingService.getValuesMapping(data).subscribe({
      next: (res) => {
        this.nodes = res;
        this.totalRecords = this.getTotalRecords(this.nodes);
        this.updateNodesWithAssociatedValues();
        this.loading = false;
      },
    });
  }

 findMatchingOption(value: any, nodeMapping): any {
    if (!value || !nodeMapping?.values) {
      return null;
    }
    
    // Si value est un objet avec valueLabel
    if (typeof value === 'object' && value.valueLabel) {
      return nodeMapping.values.find(option => 
        option.valueLabel === value.valueLabel
      );
    }
    
    // Si value est une chaîne
    if (typeof value === 'string') {
      return nodeMapping.values.find(option => 
        option.valueLabel === value
      );
    }
    
    return null;
}

updateMappedValue(selectedOption: any, node): void {
  if (selectedOption) {
    // Stocker à la fois valueLabel et valueCode
    node.mappedValue = {
      valueLabel: selectedOption.valueLabel,
      valueCode: selectedOption.valueCode
    };
  } else {
    node.mappedValue = null;
  }
}
  
  private getTotalRecords(nodes): number {
    return nodes?.length > 0 ? nodes[0].total : 0;
  }
  
  private updateNodesWithAssociatedValues(): void {
    if (this.associatedNodes.length === 0) return;
  
    this.nodes = this.nodes.map((node) => ({
      ...node,
      details: this.mapDetailsWithAssociatedValues(node.details),
    }));
  }
  
  private mapDetailsWithAssociatedValues(details) {
    return details.map((value) => {
      const matchingAssociatedValue = this.associatedNodes.find(
        (av) => av.vendorValue === value.vendorValue
      );
  
      return {
        ...value,
        associated: matchingAssociatedValue?.associated ?? null,
        mappedValue: matchingAssociatedValue?.mappedValue ?? value.mappedValue,
      };
    });
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const currentPage = event.first / this.rows;
    this.loading = true;
    const importId = this.route.snapshot.paramMap.get('id');
    const data = {
      vendorId: this.importShopCode,
      importId: importId,
      filter: {
        locale: this.channelService.getSelectedLocale(),
        label: this.searchKeyword,
        offset: currentPage,
        limit: this.rows,
      },
    };

    this.getMappingValues(data);
  }

  filterGlobal(event) {
    this.searchKeyword = event.target.value;
    this.onLazyLoad({ first: 0, rows: this.rows });
  }



  

  associate(node, nodeMapping) {
    if (node.mappedValue) {
      node.associated = true;
      node.vendorAttribute = nodeMapping.vendorAttribute
  
      if (typeof node.mappedValue === 'string') {
        node.mappedValue = nodeMapping.values.find(option => option.valueLabel === node.mappedValue);
      }
      
      this.associatedNodes.push(node);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'messages.error',
        detail: 'mapping.chooseValue',
      });
    }
  }

  customValueSelection(node) {
    this.workingNode = node;
    this.showDialog = true;
  }

  mapValue() {
    this.workingNode.mappedValue = structuredClone(this.selectedValue.ValueCode);
    this.selectedValue = null;
    this.showDialog = false;
  }

  startMappingForAttribute() {
    this.details.push(structuredClone(this.selectedNode));
    this.nodes = this.nodes.filter((node) => node.attributeCode != this.selectedNode.attributeCode);
    this.selectedNode = null;
  }

  finishMapping() {
    return this.associatedNodes.map((node) => {
      let mappedValue = node.mappedValue;
      return {
        vendorId: this.importShopCode,
        importId: this.route.snapshot.paramMap.get('id'),
        vendorValue: node.vendorValue,
        mappedAttribute: node.mappedAttribute,
        vendorAttribute : node.vendorAttribute,
        mappedValue: mappedValue,
      };
    });
  }

  intitAttributes() {
    this.attributes = [];
    this.selectedAttribute = null;
    this.categoryService
      .getAttributesByLocale(this.selectedCategory.categoryId, this.channelService.getSelectedLocale())
      .subscribe({
        next: (res: any) => {
          this.attributes = res[1];
        },
      });
  }

  initCategories() {
    Util.initCategories(this.categoryService, this.channelService)()
    .then(categories => {
      this.categories = categories;
      for (let node of this.categories) {
        Util.handleSlectableNodes(node);
      }
    });
  }


  onCategorySelect(event) {}

  onAttributeSelect(event) {}

  onClear() {}
}
